import(/* webpackMode: "eager" */ "/workspace/app/project/taxi-booking/taxi-booking.module.css");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@14.2.24_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@14.2.24_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/workspace/public/assets/images/brand/logo-dark.png");
;
import(/* webpackMode: "eager" */ "/workspace/public/assets/images/brand/logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/cards/testimonial/rating/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/workspace/src/components/carousel/index.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/container/container.module.css");
;
import(/* webpackMode: "eager" */ "/workspace/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollArea"] */ "/workspace/src/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sheet","SheetTrigger","SheetContent","SheetClose"] */ "/workspace/src/components/ui/sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/layout/header/desktop/v1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/workspace/src/layout/header/desktop/v2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSection"] */ "/workspace/src/sections/about/v1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/sections/industries/v1/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectSection"] */ "/workspace/src/sections/project/v3/index.tsx");
